import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

import { Action } from '../../../../../../components/index';
import ModalConfirm from '../../../../../../components/modal-confirm/ModalConfirm';
import { TrashAltIcon } from '../../../../../../components/icon/regular';
import { MediaStyles } from '../styles';
import { deleteArticleRequest } from '../../../../../../store/modules/articles/actions';

type Props = {
  itemId: number;
};

const DeleteAction = ({ itemId }: Props) => {
  const classes = MediaStyles();
  const dispatch = useDispatch();

  const [confirmOpened, setConfirmOpened] = useState(false);

  const clickHandler = useCallback(() => {
    setConfirmOpened(true);
  }, [setConfirmOpened]);

  const closeHandler = useCallback(() => {
    setConfirmOpened(false);
  }, [setConfirmOpened]);

  const confirmHandler = useCallback(() => {
    closeHandler();
    dispatch(deleteArticleRequest(itemId));
  }, [closeHandler, dispatch, itemId]);

  return (
    <>
      <Action
        icon={<TrashAltIcon className={clsx(classes.actionIcon, classes.deleteIcon)} />}
        title="Delete"
        onClick={clickHandler}
      />
      <ModalConfirm
        open={confirmOpened}
        onClose={closeHandler}
        onCancel={closeHandler}
        onConfirm={confirmHandler}
      />
    </>
  );
};

export default DeleteAction;
